module.exports = __webpack_public_path__ + "static/img/bg_jjfa_le.b9ad6bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_jjfa_le.png
// module id = h8mi
// module chunks = 15